import React from 'react';

type FilterContextType = {
  setFilter: (option: Record<string, string>) => void;
  filter: Record<string, string>;
};

const FilterContext = React.createContext<FilterContextType>({
  setFilter: () => '',
  filter: { value: 'All', label: 'All Treatments' },
});

export default FilterContext;
